<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/buildings/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Épület</h1>
          <div class="row">
            <div class="col-xs-6">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.building.name"></inputbox>
              <div class="form-group" v-if="form.building.plan_file != ''">
                <img style="width: 200px; height: auto" :src="fileSrc" alt=""/>
              </div>
              <button :disabled="uploading" v-on:click="uploadBtnClick" type="button" class="button with-icon"><i class="fas fa-upload"></i>Fájl feltöltése</button>
              <button v-if="form.building.plan_file != ''" v-on:click="fileDeleteBtnClick" type="button" class="button with-icon"><i class="fas fa-trash-alt"></i>Fájl törlése</button>
              <input accept="image/*" v-on:change="uploadFile" id="upload_file" type="file" name="upload_file" v-model="form.building.upload_file" style="position: absolute; left: -10000px"/>
            </div>
          </div>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        building: {
          name: '',
          plan_file: '',
          upload_file: ''
        },
      },
      errors: [],
      is_save: false,
      uploading: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('building/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.buildingID != undefined ? _this.$route.query.buildingID : 0), {
        success: function(response) {
          _this.form.building = response.building;
        }
      });
    });
  },

  computed: {
    fileSrc: function() {
      return 'assets/img/building/' + this.form.building.plan_file;
    }
  },

  methods: {
    fileDeleteBtnClick: function() {
      this.form.building.plan_file = '';
    },

    uploadBtnClick: function() {
      $('#upload_file').trigger('click');
    },

    uploadFile: function(e) {
      var allowed_types = new Array('image/jpg','image/jpeg');
      var file = e.target.files[0];

      if ($.inArray(file.type, allowed_types) == -1 || file.length === 0) {
        alert("Csak jpg fájl feltöltés engedélyezett.");
        return;
      }

      this.uploading = true;
      this.is_save = true;

      var reader = new FileReader();
      var _this = this;

      reader.onload = function(e) {
        _this.$root.ajax('building/upload/' + _this.$root.user.apikey, {
          method: 'POST',
          data: {
            base64: e.target.result
          },
          success: function(response) {
            _this.uploading = false;
            _this.is_save = false;
            _this.form.building.plan_file = response.filename;
            _this.form.building.upload_file = '';
          }
        });
      };
      reader.readAsDataURL(file);
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('building/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/buildings'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// building.vue?44ffd5be